import { render, staticRenderFns } from "./home_baiguullaga_ajil_bair_zar.vue?vue&type=template&id=56263fef&scoped=true&"
import script from "./home_baiguullaga_ajil_bair_zar.vue?vue&type=script&lang=js&"
export * from "./home_baiguullaga_ajil_bair_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56263fef",
  null
  
)

export default component.exports